import InfoItem from "./InfoItem"
import MainTitle from "../MainTitle"
import type { StarInfoResponse } from "@/service/api/info"

interface Props {
  starInfo?: StarInfoResponse
}

const Information = ({ starInfo }: Props) => {
  const { website, email, phone, address } = starInfo ?? {}

  // 4개 모두 없으면 안보여줌

  const noShow = !website && !email && !phone && !address
  if (noShow) {
    return null
  }

  return (
    <>
      {!noShow && (
        <div className="mb-10">
          <MainTitle title="Information" link="/" unView />
          <div className="flex flex-col gap-2 px-4 text-start">
            {website && <InfoItem title="website" value={website} />}
            {email && <InfoItem title="E-mail" value={email} />}
            {phone && <InfoItem title="Number" value={phone} />}
            {address && <InfoItem title="Address" value={address} />}
          </div>
        </div>
      )}
    </>
  )
}

export default Information
